export enum IncomingEventTypes {
  RefreshData = 'refreshData',
}

export interface BaseIncomingEvent {
  type: IncomingEventTypes;
}
